import { Check, Circle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { Estado } from '@/lib/types';

interface Props {
  estado: Estado;
  showLabel?: boolean;
}

/**
 * Badge de estado en modo "2 estados":
 *   - completado          → ✓ Completado (verde)
 *   - cualquier otro      → ○ No completado (gris)
 *
 * Los 4 estados internos del schema (sin_iniciar / en_proceso / completado /
 * detenido) se preservan para la cascada y el pipeline, pero a nivel UX se
 * muestran como completado / no completado.
 */
export function EstadoBadge({ estado, showLabel = true }: Props) {
  const isCompleted = estado === 'completado';
  return (
    <Badge variant={isCompleted ? 'success' : 'default'}>
      {isCompleted ? <Check className="h-3 w-3" strokeWidth={3} /> : <Circle className="h-3 w-3" />}
      {showLabel && <span>{isCompleted ? 'Completado' : 'No completado'}</span>}
    </Badge>
  );
}
